import { component$, useStore, $, useStyles$ } from "@builder.io/qwik";
import _ from "lodash-es";
import styles from "./style.css?inline";
import { Toaster, useToasterProvider } from "~/components/toaster/toaster";
import { saveMetaDataApi } from "~/api";
import { getUser } from "~/routes/layout";

export default component$(({ ticker, misc_data }) => {
  useStyles$(styles);
  // const state = useContext(SiteContext);
  const state = {};
  const { token } = getUser().value;
  const localState = useStore({
    isJSONView: false,
    misc_data: JSON.stringify(misc_data || [], null, 2),
  });
  const { add } = useToasterProvider();

  const defaultMetric = {
    type: "n/a",
    value: [],
  };
  const defaultQuarter = {
    datestr: "xxxx-xx-xx",
    value: 0,
  };

  const onChange = $((e, idx, str) => {
    const info = JSON.parse(localState.misc_data);
    info[idx][str] = e.target.value;
    localState.misc_data = JSON.stringify(info);
  });

  const onClick = $((e, idx, str) => {
    const info = JSON.parse(localState.misc_data);
    const checked = e.target.checked;
    info[idx][str] = checked;
    localState.misc_data = JSON.stringify(info);
  });

  const saveData = $(() => {
    saveMetaDataApi(token, ticker, JSON.parse(localState.misc_data))
      .then(() => {
        add("Successfully edited this property");
      })
      .catch(() => {
        add("Failure editing this property", { class: "btn btn-danger" });
      });
  });

  const onKeyPress = $((e) => {
    const keyCode = e.code || e.key;
    if (keyCode === "Enter") {
      saveData();
    }
  });
  const onChangeInner = $((e, idx1, idx2, str) => {
    const info = JSON.parse(localState.misc_data);
    info[idx1].value = info[idx1].value || [];
    info[idx1].value[idx2] = info[idx1].value[idx2] || {};
    info[idx1].value[idx2][str] = e.target.value;
    localState.misc_data = JSON.stringify(info);
  });

  const addMetric = $(() => {
    localState.misc_data = JSON.stringify(
      JSON.parse(localState.misc_data).concat([_.cloneDeep(defaultMetric)]),
    );
  });

  const addQuarter = $((idx1, idx2) => {
    const info = JSON.parse(localState.misc_data);
    info[idx1] = info[idx1] || {};
    const value = _.cloneDeep(info[idx1].value || []);
    info[idx1].value = value
      .slice(0, idx2)
      .concat([_.cloneDeep(defaultQuarter)])
      .concat(value.slice(idx2));
    localState.misc_data = JSON.stringify(info);
  });

  const removeQuarter = $((idx1, idx2) => {
    const info = JSON.parse(localState.misc_data);
    info[idx1] = info[idx1] || {};
    const value = _.cloneDeep(info[idx1].value || []);
    info[idx1].value = value.slice(0, idx2).concat(value.slice(idx2 + 1));
    localState.misc_data = JSON.stringify(info);
  });

  const moveUp = $((idx) => {
    if (idx <= 0) return;
    const info = JSON.parse(localState.misc_data);
    const infoNew = swap(info, idx, idx - 1);
    localState.misc_data = JSON.stringify(infoNew);
  });

  const moveDown = $((idx) => {
    const info = JSON.parse(localState.misc_data);
    if (idx >= info.length - 1) return;
    const infoNew = swap(info, idx, idx + 1);
    localState.misc_data = JSON.stringify(infoNew);
  });

  const copyMetric = $((idx) => {
    const info = JSON.parse(localState.misc_data);
    if (idx > info.length - 1) return;
    const infoNew = copyToNext(info, idx);
    localState.misc_data = JSON.stringify(infoNew);
  });

  const deleteMetric = $((idx) => {
    const info = JSON.parse(localState.misc_data);
    if (idx > info.length - 1) return;
    const infoNew = deleteIdx(info, idx);
    localState.misc_data = JSON.stringify(infoNew);
  });

  return (
    <>
      <Toaster />
      <table class="table table-striped">
        {!localState.isJSONView ? (
          <tbody>
            {JSON.parse(localState.misc_data).map((d, i) => (
              <tr>
                <td class="admin-table p-2">
                  Metric:{" "}
                  <input
                    class="form-control font-10"
                    onKeyPress$={onKeyPress}
                    onInput$={(e) => onChange(e, i, "type")}
                    value={d.type}
                  />
                  Abbreviation:{" "}
                  <input
                    class="form-control font-10"
                    onKeyPress$={onKeyPress}
                    onInput$={(e) => onChange(e, i, "abbr")}
                    value={d.abbr || ""}
                  />
                  High/Low:{" "}
                  <input
                    type="checkbox"
                    onClick$={(e) => onClick(e, i, "is_highlow")}
                    defaultChecked={d.is_highlow}
                    isChecked={d.is_highlow}
                  />
                  <br />
                  Show Abbr:{" "}
                  <input
                    type="checkbox"
                    onClick$={(e) => onClick(e, i, "show_abbr")}
                    defaultChecked={d.show_abbr === true}
                    isChecked={d.show_abbr === true}
                  />
                  <br />
                  Primary?:{" "}
                  <input
                    type="checkbox"
                    onClick$={(e) => onClick(e, i, "is_primary")}
                    defaultChecked={d.is_primary === true}
                    isChecked={d.is_primary === true}
                  />
                  <br />
                  Inverted:{" "}
                  <input
                    type="checkbox"
                    onClick$={(e) => onClick(e, i, "is_inverted")}
                    defaultChecked={d.is_inverted === true}
                    isChecked={d.is_inverted === true}
                  />
                  <br />
                  {/*isFloat: <input type='checkbox' onClick$={(e) => onClick(e, i, 'is_float')} defaultChecked={d.is_float === true} isChecked={d.is_float === true} /><br />*/}
                  <button
                    class="btn btn-sm btn-warning font-10 mr-1 mb-1"
                    onClick$={() => moveUp(i)}
                  >
                    Move Up
                  </button>
                  <button
                    class="btn btn-sm btn-warning font-10 mr-1 mb-1"
                    onClick$={() => moveDown(i)}
                  >
                    Move Down
                  </button>
                  <button
                    class="btn btn-sm btn-warning font-10 mr-1 mb-1"
                    onClick$={() => copyMetric(i)}
                  >
                    Copy metric
                  </button>
                  <button
                    class="btn btn-sm btn-warning font-10 mr-1 mb-1"
                    onClick$={() => deleteMetric(i)}
                  >
                    Delete metric
                  </button>
                  <button
                    class="btn btn-success font-10 mr-1 mb-1"
                    onClick$={() => addQuarter(i, 0)}
                  >
                    Add a report quarter
                  </button>
                </td>
                <td class="p-2 ">
                  Values:{" "}
                  {(d.value || []).map((dd, j) => {
                    return (
                      <div class="mb-1 si-vertical-center">
                        Date:{" "}
                        <input
                          class="form-control inline font-10 mr-1"
                          style="max-width: 100px"
                          onKeyPress$={onKeyPress}
                          onInput$={(e) => onChangeInner(e, i, j, "datestr")}
                          value={dd.datestr}
                        />
                        {d.is_highlow ? (
                          <>
                            High:{" "}
                            <input
                              key={`high-${j}`}
                              class="form-control inline w-25 font-10 mr-1"
                              onKeyPress$={onKeyPress}
                              onInput$={(e) => onChangeInner(e, i, j, "high")}
                              value={dd.high}
                            />
                            Low:{" "}
                            <input
                              key={`low-${j}`}
                              class="form-control inline w-25 font-10 mr-1"
                              onKeyPress$={onKeyPress}
                              onInput$={(e) => onChangeInner(e, i, j, "low")}
                              value={dd.low}
                            />
                          </>
                        ) : (
                          <>
                            Value:{" "}
                            <input
                              key={`value-${j}`}
                              class="form-control inline w-25 font-10 mr-1"
                              onKeyPress$={onKeyPress}
                              onInput$={(e) => onChangeInner(e, i, j, "value")}
                              value={dd.value}
                            />
                          </>
                        )}
                        <button
                          class="btn btn-success font-10 mr-1"
                          onClick$={() => addQuarter(i, j + 1)}
                        >
                          Insert Q after
                        </button>
                        <button
                          class="btn btn-danger font-10 mr-1"
                          onClick$={() => removeQuarter(i, j)}
                        >
                          Remove
                        </button>
                      </div>
                    );
                  })}
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td>
                <textarea
                  rows="9"
                  class="w-75 inline"
                  value={localState.misc_data}
                  onInput$={(e) => (localState.misc_data = e.target.value)}
                  placeholder="name"
                />
              </td>
            </tr>
          </tbody>
        )}
        <button class="btn btn-success font-10 mr-1 mb-1" onClick$={addMetric}>
          Add a metric
        </button>
        <button
          class="btn btn-info font-10 mr-1 mb-1"
          onClick$={() => (localState.isJSONView = !localState.isJSONView)}
        >
          Change To JSONView
        </button>
        <button class="btn btn-danger font-10 mr-1 mb-1" onClick$={saveData}>
          Save Data
        </button>
        <br />
      </table>
    </>
  );
});

// export async function saveMetaData(token: string, ticker: string, meta: any): Promise<any[]> {
//   const resp = await fetch(`${config.getApiUrl()}/admin/tickers/${ticker.toLowerCase()}/misc-data`, {
//     method: 'POST',
//     headers: {
//         Authorization: `Bearer ${ token }`,
//         'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({ data: meta })
//   });
//   return await resp.json();
// }

export const swap = (info, idx1, idx2) => {
  const infoNew = _.cloneDeep(info);
  const t = _.cloneDeep(infoNew[idx1]);
  infoNew[idx1] = _.cloneDeep(infoNew[idx2]);
  infoNew[idx2] = t;
  return infoNew;
};

export const copyToNext = (info, idx) => {
  const infoNew = _.cloneDeep(info);
  const t = _.cloneDeep(infoNew[idx]);
  t.type += " (Copied)";
  t.abbr = "";
  return infoNew
    .slice(0, idx + 1)
    .concat([t])
    .concat(infoNew.slice(idx + 1));
};

export const deleteIdx = (info, idx) => {
  const infoNew = _.cloneDeep(info);
  return infoNew.slice(0, idx).concat(infoNew.slice(idx + 1));
};
